export default {
  delivered: {
    'link-feedback-popup': {
      title: '感谢您使用我们的服务，我们非常重视您的反馈。',
      subtitle: '请在我们的Google页面留下评价',
      btn: '确定',
    },
    info: {
      'payment-delivered-title': '已送达',
    },
    feedback: {
      title: '您的反馈对我们很重要',
      comment: {
        title: '请留下您的评论：',
        placeholder: '写下您是否满意，您的期望和感受',
        'send-btn': '发送反馈',
        'change-btn': '修改反馈',
        'not-send-tooltip': {
          text: '联系我',
          title: '客服将致电您',
          content: '请留下您的反馈，我们的客服人员将尽快与您联系。',
        },
      },
      suggestions: {
        driver: {
          positive: {
            'went-above-and-beyond': '超出预期',
            'professional-appearance': '专业的外观',
            'courteous-and-respectful': '礼貌且尊重',
            'on-time-delivery': '准时送达',
          },
          negative: {
            'unfriendly-driver': '司机态度不好',
            'did-not-follow-instructions': '未遵循指示',
            'late-delivery': '送达迟到',
            'unprofessional-appearance': '外观不专业',
          },
        },
        dispatcher: {
          positive: {
            'great-communication': '沟通良好',
            'patient-and-understanding': '耐心且理解',
            'efficient-coordination': '协调高效',
            'quick-response-time': '响应迅速',
          },
          negative: {
            'impatient-or-rude': '不耐烦或粗鲁',
            'poor-coordination': '协调不佳',
            'failed-to-address-concerns': '未解决问题',
            'slow-response-time': '响应缓慢',
          },
        },
        pharmacy: {
          positive: {
            'friendly-staff': '工作人员友好',
            'secure-packaging': '包装安全',
            'fast-shipping': '快速发货/续药',
            'concise-medication-instructions': '用药说明简明',
          },
          negative: {
            'difficult-to-open': '难以打开',
            'incorrect-prescription': '处方错误',
            'unfriendly-staff': '工作人员态度不好',
            'wrong-medication': '药品错误',
          },
        },
      },
    },
  },
  delivering: {
    confirmed: {
      'stops-away': '站点外',
      'your-stop-is-next': '您的站点即将到达',
      'special-instruction': {
        title: '药房特殊指示：',
        'new-instruction-input': {
          title: '收件人特殊指示',
          placeholder: '添加特殊指示',
        },
        'new-instruction-btn-save': '保存',
        'not-editable-warning': '抱歉，司机已接近，无法更改特殊指示。',
      },
      'arriving-data': {
        today: {
          'label-2': '今日送达',
          label: '预计送达时间',
        },
        next: {
          label: '司机将在',
          time: '几分钟内到达',
        },
        'few-minutes': {
          'label-2': '司机将在几分钟内到达',
        },
      },
      qr: {
        info: '请向司机出示二维码',
        description: '收货时，请向司机展示二维码或拨打代码',
        help: '共付额是您根据保险计划规定需为医疗服务或处方支付的特定金额。',
      },
    },
    'confirmed-no-route': {
      title: '您已确认送货',
      subtitle: '请等待信息更新',
    },
    'not-confirmed': {
      form: {
        'empty-title': '请务必留下签名',
        'pharmacy-instruction-title': '药房特殊指示：',
        'recipient-instruction': {
          title: '收件人特殊指示：',
          placeholder: '添加特殊指示',
          'update-btn': '更新',
        },
        sign: {
          description: '司机将尝试面对面送货。如无人应答，司机会将包裹放置门口并拍照。',
          confirm: {
            btn: '确认送货',
            title: '您确定吗？',
            text: '我确认我提供的信息正确无误',
          },
        },
      },
      progress: {
        attempts: '送货尝试：',
        created: '订单<br>已创建',
      },
      transit: '运输中',
      'out-for-delivery': '派送中<br>',
      delivered: '已送达',
      signature: {
        title: '请在下方签名以允许无签名放包裹：',
        clear: '清除',
      },
      statuses: {
        'at-pharmacy': '您的订单已在药房，准备送货',
        'driver-out': '确认送货',
        rescheduled: '送货已重新安排，时间为',
        'pending-back-to-pharmacy': '您的订单待退回药房',
        'pickup-occured': '您的订单已从药房取出，正在派送',
      },
    },
    rescheduled: {
      attempted: '尝试送货时间',
    },
  },
  investigation: {
    link_start: '请联系我们，电话：',
    link_end: '安排送货',
    instructions: '药房特殊指示：',
  },
  rescadule: {
    subtitle: '请选择新的送货日期',
  },
  rejected: {
    'back-to-pharmacy': {
      rejected: '订单已被药房取消',
      'pending-back-to-pharmacy': '订单已取消，待退回药房',
      'on-its-way-to-pharmacy': '订单已取消，确认退回药房中',
      default: '订单已取消，正在退回药房',
      'confirmed-back-to-pharmacy': '订单已取消，等待药房确认退货',
      'back-to-pharmacy': '订单已取消，已退回药房',
    },
  },
  returned: {
    'back-to-pharmacy': {
      title: '您的订单待退回药房',
    },
  },
}
